import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=3954ce34&scoped=true&"
import script from "./ChatRoom.vue?vue&type=script&lang=js&"
export * from "./ChatRoom.vue?vue&type=script&lang=js&"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&id=3954ce34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3954ce34",
  null
  
)

export default component.exports